import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// ─── SCHEMA (run this in Supabase SQL editor once) ───────────────────────────
//
// -- Profiles (extends Supabase auth.users)
// create table profiles (
//   id uuid references auth.users on delete cascade primary key,
//   full_name text,
//   role text check (role in ('supervising_ad','ad','am','technician')),
//   avatar_color text default '#2e3a59',
//   created_at timestamptz default now()
// );
// alter table profiles enable row level security;
// create policy "Users can read all profiles" on profiles for select using (auth.role() = 'authenticated');
// create policy "Users can update own profile" on profiles for update using (auth.uid() = id);
//
// -- Clients
// create table clients (
//   id uuid default gen_random_uuid() primary key,
//   name text not null,
//   is_onboarding boolean default true,
//   onboarding_started_at timestamptz default now(),
//   onboarding_complete boolean default false,
//   created_at timestamptz default now()
// );
// alter table clients enable row level security;
// create policy "Authenticated users can manage clients" on clients for all using (auth.role() = 'authenticated');
//
// -- Tasks
// create table tasks (
//   id uuid default gen_random_uuid() primary key,
//   client_id uuid references clients(id) on delete cascade,
//   title text not null,
//   description text,
//   service_area text check (service_area in ('ads','seo','website','social','email','design','copywriting','account_management','other')),
//   service_subarea text,
//   week_number integer,
//   assigned_to uuid references profiles(id),
//   assigned_by uuid references profiles(id),
//   date_assigned timestamptz default now(),
//   date_due timestamptz,
//   status text check (status in ('not_started','in_progress','ready_for_review','approved','blocked')) default 'not_started',
//   notes text,
//   google_doc_links text[] default '{}',
//   loom_links text[] default '{}',
//   is_onboarding_task boolean default false,
//   client_visible boolean default false,
//   created_at timestamptz default now(),
//   updated_at timestamptz default now()
// );
// alter table tasks enable row level security;
// create policy "Authenticated users can manage tasks" on tasks for all using (auth.role() = 'authenticated');
//
// -- Notifications
// create table notifications (
//   id uuid default gen_random_uuid() primary key,
//   user_id uuid references profiles(id),
//   task_id uuid references tasks(id) on delete cascade,
//   type text,
//   message text,
//   read boolean default false,
//   created_at timestamptz default now()
// );
// alter table notifications enable row level security;
// create policy "Users see own notifications" on notifications for all using (auth.uid() = user_id);
//
// -- Trigger: updated_at on tasks
// create or replace function update_updated_at()
// returns trigger as $$ begin new.updated_at = now(); return new; end; $$ language plpgsql;
// create trigger tasks_updated_at before update on tasks for each row execute function update_updated_at();
//
// ─────────────────────────────────────────────────────────────────────────────
